import React from "react";

import moment from "moment";
import Flatpickr from "react-flatpickr";
import Tooltip from "@material-ui/core/Tooltip";

import PartySelect from "../form/PartySelect";

import Input from "./Input";
import CodeInput from "./CodeInput";
import Operations from "./Operations";
import Valuation from "./Valuation";
import Collapsible from "./Collapsible";
import Documents from "./Documents";
import Packages from "./Packages";
import AdditionalProcedures from "./AdditionalProcedures";
import AdditionalInformation from "./AdditionalInformation";
import AdditionalReferences from "./AdditionalReferences";
import AdditionalFiscalReferences from "./AdditionalFiscalReferences";
import TransportDocuments from "./TransportDocuments";
import DangerousGoods from "./DangerousGoods";
import Containers from "./Containers";

import ProductSettings from "../modal/ProductSettings";

import Notify from "../../../utils/Notify";
import AuthManager from "../../../utils/AuthManager";
import FormUtils from "../../../utils/Form";

export default class Form extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: props.show,
      accordionKey: 0,
      ...this._getState(props),
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this._getState(nextProps));
  }

  _hidden(sectionId) {
    let { filteredFormType, filteredFormSubType } = this.state;

    const type = filteredFormType
    const subtype = filteredFormSubType

    let formTypeVisibleSectionIds = VISIBLE_SECTIONS[type];

    if (!formTypeVisibleSectionIds) {
      return false;
    }

    let visibleSectionIds = formTypeVisibleSectionIds[subtype];
    if (!visibleSectionIds) {
      return false;
    }

    return visibleSectionIds.indexOf(sectionId) === -1;
  }

  _placeholder(key, defaultValue) {
    let { filteredFormType, filteredFormSubType } = this.state;

    let type = filteredFormType
    type = ["aes","nhd"].indexOf(type) === -1 ? "legacy" : "standard"

    let mappings = DATA_ELEMENT_MAPPINGS[key];

    if (!mappings) {
      return defaultValue;
    }

    let value = mappings[type];
    if (!value) {
      return defaultValue;
    }

    return value;
  }

  _fieldVisibilityClassName(key) {
    let { showHiddenFields } = this.state;
    if (showHiddenFields) {
      return "";
    }

    let fieldSetting = this._getFieldSetting(key);
    return fieldSetting.hidden ? "d-none" : "";
  }

  _isHiddenField(key) {
    let { showHiddenFields } = this.state;
    if (showHiddenFields) {
      return false;
    }

    let fieldSetting = this._getFieldSetting(key);
    return fieldSetting.hidden;
  }

  _isEditableField(key) {
    let fieldSetting = this._getFieldSetting(key);
    return fieldSetting.editable;
  }

  _isExpandedField(key) {
    let fieldSetting = this._getFieldSetting(key);
    return fieldSetting.expanded;
  }

  _getFieldSetting(key) {
    let { submission, product } = this.state;

    let extra = product.extra || {};
    return (
      extra[key] || {
        hidden: false,
        editable: true,
        expanded: submission ? false : true,
      }
    );
  }

  _getState(props) {
    return {
      editable: props.editable,
      submission: props.submission,
      showHiddenFields: props.showHiddenFields,
      filteredFormType: props.filteredFormType,
      filteredFormSubType: props.filteredFormSubType,
      product: props.product || FormUtils.getItemTemplate(),
    };
  }

  _isFormValid() {
    let { product } = this.state;

    let error = null;

    if (!product.name) {
      error = "Please enter a name";
    } else if (!product.description) {
      error = "Please enter a description";
    } else if (!product.quantity) {
      error = "Please enter the quantify";
    } else if (!product.commodity_code.taric) {
      error = "Please select a TARIC code";
    }

    if (error) {
      Notify.error(error);
      return false;
    }

    return true;
  }

  _renderInput(type, key, placeholder, required = false) {
    let { product, editable, showHiddenFields } = this.state;

    if (!showHiddenFields && this._isHiddenField(key)) {
      return null;
    }

    placeholder = this._placeholder(key, placeholder);

    return (
      <Input
        type={type}
        editable={editable && this._isEditableField(key)}
        className="form-control"
        placeholder={placeholder}
        value={product[key]}
        onChange={(value) => {
          product[key] = value;
          this.props.onUpdated(product);
        }}
        renderToolbar={() => this._renderSetting(key, placeholder)}
      />
    );
  }

  _renderCodeInput(
    listKey,
    value,
    placeholder,
    required = false,
    onSelected,
    nameKey = "name",
    queryParams = {},
    isMulti = false,
    allowCopy = false
  ) {
    let { editable, showHiddenFields } = this.state;

    let key = placeholder;
    if (!showHiddenFields && this._isHiddenField(key)) {
      return null;
    }

    placeholder = this._placeholder(placeholder, placeholder);

    return (
      <CodeInput
        placeholder={placeholder}
        listKey={this._getListKey(listKey)}
        value={value}
        required={required}
        editable={editable && this._isEditableField(key)}
        onSelected={onSelected}
        nameKey={nameKey}
        queryParams={queryParams}
        isMulti={isMulti}
        allowCopy={allowCopy}
        renderToolbar={() => this._renderSetting(key, placeholder)}
      />
    );
  }

  _renderSetting(key, title, section = false) {
    let { product, submission } = this.state;
    let isCompanyMember = AuthManager.currentUser.user.role == "company_member";

    if (!submission || !submission.template || !isCompanyMember) {
      return null;
    }

    return (
      <Tooltip
        title={
          <p style={{ fontSize: 12, padding: 8, marginBottom: 0 }}>Settings</p>
        }
        fontSize={16}
        placement="top"
        arrow
        className="mb-1"
      >
        <a
          onClick={(e) => {
            this.setState({
              showSettingsModal: true,
              selectedSetting: {
                key,
                title,
                section,
              },
            });
          }}
        >
          <span class="svg-icon-help svg-icon-2x">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              width="18px"
              height="18px"
              viewBox="0 0 24 24"
              version="1.1"
            >
              <defs />
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <rect x="0" y="0" width="24" height="24" />
                <path
                  d="M5,8.6862915 L5,5 L8.6862915,5 L11.5857864,2.10050506 L14.4852814,5 L19,5 L19,9.51471863 L21.4852814,12 L19,14.4852814 L19,19 L14.4852814,19 L11.5857864,21.8994949 L8.6862915,19 L5,19 L5,15.3137085 L1.6862915,12 L5,8.6862915 Z M12,15 C13.6568542,15 15,13.6568542 15,12 C15,10.3431458 13.6568542,9 12,9 C10.3431458,9 9,10.3431458 9,12 C9,13.6568542 10.3431458,15 12,15 Z"
                  fill="#999999"
                />
              </g>
            </svg>
          </span>
        </a>
      </Tooltip>
    );
  }

  _getListKey(defaultKey){
    let { submission } = this.state;

    if(!submission || !submission.form){
      return defaultKey;
    }

    const form = submission.form
    const mappings = LIST_KEY_MAPPINGS[defaultKey]

    if(!mappings){
      return defaultKey;
    }

    if(form.type === "cds"){
      if(form.subtype === "BIRDS" && mappings.birds) {
        return mappings.birds
      }
      if(EXPORT_SUBTYPES.indexOf(form.subtype) > -1 && mappings.cds_export) {
        return mappings.cds_export
      }
      if(IMPORT_SUBTYPES.indexOf(form.subtype) > -1 && mappings.cds_import) {
        return mappings.cds_import
      }
      if(mappings.cds) {
        return mappings.cds
      }
    }

    if(form.type === "aes" && mappings.aes) {
      return mappings.aes
    }

    if(form.type === "ais" && mappings.ais) {
      return mappings.ais
    }

    if(form.type === "nhd" && form.subtype === "H1" && mappings.dms) {
      return mappings.dms
    }

    if(form.type === "nhd" && mappings.nhd) {
      return mappings.nhd
    }

    return defaultKey
  }

  render() {
    let {
      product,
      editable,
      accordionKey,
      selectedSetting,
      showHiddenFields,
      showSettingsModal,
    } = this.state;

    return (
      <div className={"item-form"}>
        <div className="row">
          <div
            hidden={this._hidden("name")}
            className={`col ${this._fieldVisibilityClassName("name")}`}
          >
            <div className="fv-row mb-4">
              {this._renderInput("text", "name", "Name", true)}
            </div>
          </div>
          <div
            hidden={this._hidden("description")}
            className={`col ${this._fieldVisibilityClassName("description")}`}
          >
            <div className="fv-row mb-4">
              {this._renderInput(
                "text",
                "description",
                "Description (6/8)",
                true
              )}
            </div>
          </div>
          <div
            hidden={this._hidden("gross_mass")}
            className={`col ${this._fieldVisibilityClassName("gross_mass")}`}
          >
            <div className="fv-row mb-4">
              {this._renderInput(
                "number",
                "gross_mass",
                "Gross Mass (6/5)",
                false
              )}
            </div>
          </div>
          <div
            hidden={this._hidden("net_mass")}
            className={`col ${this._fieldVisibilityClassName("net_mass")}`}
          >
            <div className="fv-row mb-4">
              {this._renderInput("number", "net_mass", "Net Mass (6/1)", false)}
            </div>
          </div>
          <div
            hidden={this._hidden("supplementary_units")}
            className={`col ${this._fieldVisibilityClassName(
              "supplementary_units"
            )}`}
          >
            <div className="fv-row mb-4">
              {this._renderInput(
                "number",
                "supplementary_units",
                "Supplementary Units (6/2)",
                false
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <div
            hidden={this._hidden("postal_value")}
            className={`col ${this._fieldVisibilityClassName(
              "postal_value"
            )}`}
          >
            <div className="fv-row mb-4">
              {this._renderInput(
                "number",
                "postal_value",
                "Postal Value",
                false
              )}
            </div>
          </div>

          <div
            hidden={this._hidden("postal_currency")}
            className={`col ${this._fieldVisibilityClassName(
              "postal_currency"
            )}`}
          >
            <div className="fv-row mb-4">
              {this._renderCodeInput(
                "Currencies",
                product.postal_currency,
                "Postal Currency",
                false,
                (option) => {
                  product.postal_currency = option;
                  this.props.onUpdated(product);
                },
                "value",
                {},
                false,
                true
              )}
            </div>
          </div>


          <div
            hidden={this._hidden("goods_type")}
            className={`col ${this._fieldVisibilityClassName(
              "goods_types"
            )}`}
          >
            <div className="fv-row mb-4">
              {this._renderCodeInput(
                "TypesOfGoods_ICS2",
                product.goods_type,
                "Type Of Goods",
                false,
                (option) => {
                  product.goods_type = option;
                  this.props.onUpdated(product);
                },
                "value",
                {},
                false,
                true
              )}
            </div>
          </div>
        </div>

        <div
          className="accordion"
          id="shipmentItemSections"
          key={`${accordionKey}_${showHiddenFields}`}
        >
          <Collapsible
            id={"taric-codes"}
            title={"TARIC"}
            defaultExpanded={this._isExpandedField("taric_section")}
            hidden={
              this._hidden("commodity_code") || this._isHiddenField("taric_section")
            }
            renderToolbar={() =>
              this._renderSetting("taric_section", "TARIC", true)
            }
          >
            <div className="row">
              <div
                hidden={this._hidden("commodity_code.taric")}
                className={`col-md-3 ${this._fieldVisibilityClassName(
                  "TARIC Code (6/15)"
                )}`}
              >
                <div className="fv-row mb-4">
                  {this._renderCodeInput(
                    "NomenclatureCode",
                    product.commodity_code.taric,
                    "TARIC Code (6/15)",
                    true,
                    (option) => {
                      product.commodity_code.taric = option;
                      product.y_codes = [];
                      this.props.onUpdated(product);
                    },
                    "value",
                    {},
                    false,
                    true
                  )}
                </div>
              </div>
              <div
                hidden={this._hidden("y_codes")}
                className={`col-md-3 ${this._fieldVisibilityClassName(
                  "Y Codes"
                )}`}
              >
                <div
                  key={product.commodity_code.taric?.id}
                  className="fv-row mb-4"
                >
                  {this._renderCodeInput(
                    "CommonDocumentsType",
                    product.y_codes.map((yCode) => yCode.code),
                    "Y Codes",
                    false,
                    (codes) => {
                      product.y_codes =
                        codes?.map((code) => {
                          return {
                            code,
                          };
                        }) || [];
                      this.props.onUpdated(product);
                    },
                    "value",
                    {
                      cites_search_term: "Y",
                      cites_id: product.commodity_code.taric?.id,
                    },
                    true
                  )}
                </div>
              </div>
              <div
                hidden={this._hidden("procedure")}
                className={`col-md-3 ${this._fieldVisibilityClassName(
                  "Procedure Code (1/10)"
                )}`}
              >
                <div className="fv-row mb-4">
                  {this._renderCodeInput(
                    "ProcedureCode",
                    product.procedure,
                    "Procedure Code (1/10)",
                    true,
                    (option) => {
                      product.procedure = option;
                      this.props.onUpdated(product);
                    }
                  )}
                </div>
              </div>

              <div
                hidden={this._hidden("previous_procedure")}
                className={`col-md-3 ${this._fieldVisibilityClassName(
                  "Previous Procedure Code (1/10)"
                )}`}
              >
                <div className="fv-row mb-4">
                  {this._renderCodeInput(
                    "ProcedureCode",
                    product.previous_procedure,
                    "Previous Procedure Code (1/10)",
                    false,
                    (option) => {
                      product.previous_procedure = option;
                      this.props.onUpdated(product);
                    }
                  )}
                </div>
              </div>

              <div
                hidden={this._hidden("cus_code")}
                className={`col-md-3 ${this._fieldVisibilityClassName(
                  "Cus Code (6/13)"
                )}`}
              >
                <div className="fv-row mb-4">
                  {this._renderInput(
                    "text",
                    "cus_code",
                    "Cus Code (6/13)",
                    false
                  )}
                </div>
              </div>

              <div
                hidden={this._hidden("quota_order_no")}
                className={`col-md-3 ${this._fieldVisibilityClassName(
                  "Quota Order Number (8/1)"
                )}`}
              >
                <div className="fv-row mb-4">
                  {this._renderInput(
                    "text",
                    "quota_order_no",
                    "Quota Order Number (8/1)",
                    false
                  )}
                </div>
              </div>

              <div
                hidden={this._hidden("commodity_code.taric_additional_codes")}
                className={`col-md-3 ${this._fieldVisibilityClassName(
                  "Taric Additional Codes (6/16)"
                )}`}
              >
                <div className="fv-row mb-4">
                  {this._renderCodeInput(
                    "TaricAdditionalCode",
                    product.commodity_code.taric_additional_codes.map(
                      (code) => code.code
                    ),
                    "Taric Additional Codes (6/16)",
                    false,
                    (codes) => {
                      product.commodity_code.taric_additional_codes =
                        codes?.map((code) => {
                          return {
                            code,
                          };
                        }) || [];
                      this.props.onUpdated(product);
                    },
                    "value",
                    {},
                    true
                  )}
                </div>
              </div>

              <div
                hidden={this._hidden("commodity_code.national_additional_codes")}
                className={`col-md-3 ${this._fieldVisibilityClassName(
                  "National Additional Codes (6/17)"
                )}`}
              >
                <div className="fv-row mb-4">
                  {this._renderCodeInput(
                    "TaricNationalAdditionalCode",
                    product.commodity_code.national_additional_codes.map(
                      (code) => code.code
                    ),
                    "National Additional Codes (6/17)",
                    false,
                    (codes) => {
                      product.commodity_code.national_additional_codes =
                        codes?.map((code) => {
                          return {
                            code,
                          };
                        }) || [];
                      this.props.onUpdated(product);
                    },
                    "value",
                    {},
                    true
                  )}
                </div>
              </div>
            </div>
          </Collapsible>

          <Collapsible
            id={"valuation"}
            title={"Product Valuation"}
            defaultExpanded={this._isExpandedField("valuation_section")}
            hidden={
              this._hidden("valuation") ||
              this._isHiddenField("valuation_section")
            }
            renderToolbar={() =>
              this._renderSetting(
                "valuation_section",
                "Product Valuation",
                true
              )
            }
          >
            <Valuation
              editable={editable}
              product={product}
              valuation={product.valuation}
              placeholder={(key, value) => this._placeholder(key, value)}
              onUpdated={(valuation) => {
                product.valuation = valuation;
                this.props.onUpdated(product);
              }}
              onQuantityUpdated={(quantity) => {
                product.quantity = quantity;
                this.props.onUpdated(product);
              }}
              onTransactionNatureUpdated={(transactionNature) => {
                product.transaction_nature = transactionNature;
                this.props.onUpdated(product);
              }}
              isEditableField={(key) => this._isEditableField(key)}
              renderToolbar={(key, placeholder) =>
                this._renderSetting(key, placeholder)
              }
              hidden={(key) => this._hidden(key)}
              fieldVisibilityClassName={(key) =>
                this._fieldVisibilityClassName(key)
              }
            />
          </Collapsible>

          <Collapsible
            id={"previous-document"}
            title={"Previous Document"}
            defaultExpanded={this._isExpandedField(
              "previous_documents_section"
            )}
            hidden={
              this._hidden("previous_documents") ||
              this._isHiddenField("previous_documents_section")
            }
            renderToolbar={() =>
              this._renderSetting(
                "previous_documents_section",
                "Previous Document",
                true
              )
            }
          >
            <div className="row">
              <div
                hidden={this._hidden("previous_document_type")}
                className={`col ${this._fieldVisibilityClassName(
                  "Previous Document Type"
                )}`}
              >
                <div className="fv-row mb-4">
                  {this._renderCodeInput(
                    "PreviousDocumentType",
                    product.previous_document_type,
                    "Previous Document Type",
                    false,
                    (option) => {
                      product.previous_document_type = option;
                      this.props.onUpdated(product);
                    }
                  )}
                </div>
              </div>

              <div
                hidden={this._hidden("previous_document_identifier")}
                className={`col ${this._fieldVisibilityClassName(
                  "Previous Document Identifier"
                )}`}
              >
                <div className="fv-row mb-4">
                  {this._renderInput(
                    "text",
                    "previous_document_identifier",
                    "Previous Document Identifier",
                    true
                  )}
                </div>
              </div>
              <div
                hidden={this._hidden("previous_document_line_id")}
                className={`col ${this._fieldVisibilityClassName(
                  "Previous Document Line ID"
                )}`}
              >
                <div className="fv-row mb-4">
                  {this._renderInput(
                    "text",
                    "previous_document_line_id",
                    "Previous Document Line ID",
                    true
                  )}
                </div>
              </div>
            </div>
          </Collapsible>

          <Collapsible
            id={"dates-places"}
            title="Dates & Places"
            defaultExpanded={this._isExpandedField("dates_places_section")}
            hidden={
              this._hidden("dates_and_places") ||
              this._isHiddenField("dates_places_section")
            }
            renderToolbar={() =>
              this._renderSetting(
                "dates_places_section",
                "Dates & Places",
                true
              )
            }
          >
            <div className="row">
              <div
                hidden={this._hidden("dates_and_places.destination_country")}
                className={`col-4 ${this._fieldVisibilityClassName(
                  "Destination Country (5/8)"
                )}`}
              >
                {this._renderCodeInput(
                  "CountryCodesEU",
                  product.dates_and_places.destination_country,
                  "Destination Country (5/8)",
                  false,
                  (option) => {
                    product.dates_and_places.destination_country = option;
                    this.props.onUpdated(product);
                  }
                )}
              </div>
              <div
                hidden={this._hidden("dates_and_places.destination_region")}
                className={`col-4 ${this._fieldVisibilityClassName(
                  "Destination Region (5/9)"
                )}`}
              >
                {this._renderCodeInput(
                  "DestinationRegionCode",
                  product.dates_and_places.destination_region,
                  "Destination Region (5/9)",
                  false,
                  (option) => {
                    product.dates_and_places.destination_region = option;
                    this.props.onUpdated(product);
                  }
                )}
              </div>
              <div
                hidden={this._hidden("dates_and_places.dispatch_country")}
                className={`col-4 ${this._fieldVisibilityClassName(
                  "Dispatch Country (5/14)"
                )}`}
              >
                <div className="fv-row mb-3">
                  {this._renderCodeInput(
                    "CountryCodesFullList",
                    product.dates_and_places.dispatch_country,
                    "Dispatch Country (5/14)",
                    false,
                    (option) => {
                      product.dates_and_places.dispatch_country = option;
                      this.props.onUpdated(product);
                    }
                  )}
                </div>
              </div>
              <div
                hidden={this._hidden("dates_and_places.origin_country")}
                className={`col-4 ${this._fieldVisibilityClassName(
                  "Origin Country (5/15)"
                )}`}
              >
                <div className="fv-row mb-3">
                  {this._renderCodeInput(
                    "CountryCodesFullList",
                    product.dates_and_places.origin_country,
                    "Origin Country (5/15)",
                    false,
                    (option) => {
                      product.dates_and_places.origin_country = option;
                      this.props.onUpdated(product);
                    }
                  )}
                </div>
              </div>
              <div
                hidden={this._hidden("dates_and_places.preferential_origin_country")}
                className={`col-4 ${this._fieldVisibilityClassName(
                  "Preferential Origin Country (5/16)"
                )}`}
              >
                <div className="fv-row mb-3">
                  {this._renderCodeInput(
                    "CountryCodesFullList",
                    product.dates_and_places.preferential_origin_country,
                    "Preferential Origin Country (5/16)",
                    false,
                    (option) => {
                      product.dates_and_places.preferential_origin_country =
                        option;
                      this.props.onUpdated(product);
                    }
                  )}
                </div>
              </div>
              <div
                hidden={this._hidden("dates_and_places.acceptance_date")}
                className={`col-4 ${this._fieldVisibilityClassName(
                  "Acceptance Date (5/31)"
                )}`}
              >
                <div className="fv-row mb-3">
                  <label className={"mb-2"}>
                    <span>Acceptance Date (5/31)</span>
                    {this._renderSetting(
                      "Acceptance Date (5/31)",
                      "Acceptance Date (5/31)"
                    )}
                  </label>
                  <Flatpickr
                    className="form-control "
                    value={product.dates_and_places?.acceptance_date}
                    placeholder={this._placeholder("dates_and_places.acceptance_date", "Acceptance Date")}
                    style={{height: 47.5}}
                    options={{
                      enableTime: false,
                      noCalendar: false,
                      dateFormat: "Y-m-d",
                    }}
                    disabled={
                      !editable ||
                      !this._isEditableField("Acceptance Date (5/31)")
                    }
                    onChange={(dates) => {
                      product.dates_and_places.acceptance_date = moment(
                        dates[0]
                      ).format("YYYY-MM-DD");
                      this.props.onUpdated(product);
                    }}
                  />
                </div>
              </div>
            </div>
          </Collapsible>

          <Collapsible
            id={"parties"}
            title="Parties"
            defaultExpanded={this._isExpandedField("parties_section")}
            hidden={this._hidden("parties")}
            renderToolbar={() =>
              this._renderSetting(
                "parties_section",
                "Parties",
                true
              )
            }
          >
            <div className="row">
              <div
                className={`col-4 ${this._fieldVisibilityClassName(
                  "Consignor"
                )}`}
              >
                <label className={"mb-2"}>Consignor</label>
                <PartySelect
                  party={product.consignor}
                  partyType={"consignor"}
                  placeholder={"Select Consignor"}
                  onSelected={party => {
                    product.consignor = party;
                    this.props.onUpdated(product);
                  }}
                />
              </div>
              <div
                className={`col-4 ${this._fieldVisibilityClassName(
                  "Consignee"
                )}`}
              >
                <label className={"mb-2"}>Consignee</label>
                <PartySelect
                  party={product.consignee}
                  partyType={"consignee"}
                  placeholder={"Select Consignee"}
                  onSelected={party => {
                    product.consignee = party;
                    this.props.onUpdated(product);
                  }}
                />
              </div>
              <div
                className={`col-4 ${this._fieldVisibilityClassName(
                  "Consignee"
                )}`}
              >
                {this._renderInput(
                  "text",
                  "transport_document_no",
                  "Transport Document",
                  true
                )}
              </div>
            </div>
          </Collapsible>

          <Collapsible
            id={"operations"}
            title={"Additions & Deductions"}
            defaultExpanded={this._isExpandedField("operations_section")}
            hidden={
              this._hidden("operations") ||
              this._isHiddenField("operations_section")
            }
            renderToolbar={() =>
              this._renderSetting(
                "operations_section",
                "Additions & Deductions",
                true
              )
            }
          >
            <Operations
              editable={editable}
              operations={product.valuation.operations}
              placeholder={(key, value) => this._placeholder(key, value)}
              onUpdated={(operations) => {
                product.valuation.operations = operations;
                this.props.onUpdated(product);
              }}
              hidden={(key) => this._hidden(key)}
            />
          </Collapsible>

          <Collapsible
            id={"document"}
            title={"Documents"}
            defaultExpanded={this._isExpandedField("documents_section")}
            hidden={
              this._hidden("documents") ||
              this._isHiddenField("documents_section")
            }
            renderToolbar={() =>
              this._renderSetting("documents_section", "Documents", true)
            }
          >
            <Documents
              editable={editable}
              listKey={this._getListKey("CommonDocumentsType")}
              documents={product.documents}
              placeholder={(key, value) => this._placeholder(key, value)}
              onUpdated={(documents) => {
                product.documents = documents;
                this.props.onUpdated(product);
              }}
              hidden={(key) => this._hidden(key)}
            />
          </Collapsible>

          <Collapsible
            id={"packages"}
            title={"Packages"}
            defaultExpanded={this._isExpandedField("packages_section")}
            hidden={
              this._hidden("packages") ||
              this._isHiddenField("packages_section")
            }
            renderToolbar={() =>
              this._renderSetting("packages_section", "Packages", true)
            }
          >
            <Packages
              editable={editable}
              packages={product.packages}
              placeholder={(key, value) => this._placeholder(key, value)}
              onUpdated={(documents) => {
                product.packages = documents;
                this.props.onUpdated(product);
              }}
              hidden={(key) => this._hidden(key)}
            />
          </Collapsible>

          <Collapsible
            id={"additional-procedure"}
            title={"Additional Procedures"}
            defaultExpanded={this._isExpandedField(
              "additional_procedures_section"
            )}
            hidden={
              this._hidden("additional_procedures") ||
              this._isHiddenField("additional_procedures_section")
            }
            renderToolbar={() =>
              this._renderSetting(
                "additional_procedures_section",
                "Additional Procedures",
                true
              )
            }
          >
            <AdditionalProcedures
              editable={editable}
              listKey={this._getListKey("AdditionalProcedure")}
              additionalProcedures={product.additional_procedures}
              placeholder={(key, value) => this._placeholder(key, value)}
              onUpdated={(additionalProcedures) => {
                product.additional_procedures = additionalProcedures;
                this.props.onUpdated(product);
              }}
              hidden={(key) => this._hidden(key)}
            />
          </Collapsible>

          <Collapsible
            id={"additional-information"}
            title={"Additional Information"}
            defaultExpanded={this._isExpandedField(
              "additional_information_section"
            )}
            hidden={
              this._hidden("additional_information") ||
              this._isHiddenField("additional_information_section")
            }
            renderToolbar={() =>
              this._renderSetting(
                "additional_information_section",
                "Additional Information",
                true
              )
            }
          >
            <AdditionalInformation
              editable={editable}
              listKey={this._getListKey("AdditionalInformationCode")}
              additionalInformation={product.additional_information}
              placeholder={(key, value) => this._placeholder(key, value)}
              onUpdated={(additionalInformation) => {
                product.additional_information = additionalInformation;
                this.props.onUpdated(product);
              }}
              hidden={(key) => this._hidden(key)}
            />
          </Collapsible>

          <Collapsible
            id={"additional-references"}
            title={"Additional References"}
            defaultExpanded={this._isExpandedField(
              "additional_references_section"
            )}
            hidden={
              this._hidden("additional_references") ||
              this._isHiddenField("additional_references_section")
            }
            renderToolbar={() =>
              this._renderSetting(
                "additional_references_section",
                "Additional References",
                true
              )
            }
          >
            <AdditionalReferences
              editable={editable}
              listKey={this._getListKey("AdditionalReferenceType")}
              additionalReferences={product.additional_references}
              placeholder={(key, value) => this._placeholder(key, value)}
              onUpdated={(additionalReferences) => {
                product.additional_references = additionalReferences;
                this.props.onUpdated(product);
              }}
              hidden={(key) => this._hidden(key)}
            />
          </Collapsible>

          <Collapsible
            id={"additional-fiscal-references"}
            title={"Additional Fiscal References"}
            defaultExpanded={this._isExpandedField(
              "additional_fiscal_references_section"
            )}
            hidden={
              this._hidden("additional_fiscal_references") ||
              this._isHiddenField("additional_fiscal_references_section")
            }
            renderToolbar={() =>
              this._renderSetting(
                "additional_fiscal_references_section",
                "Additional Fiscal References",
                true
              )
            }
          >
            <AdditionalFiscalReferences
              editable={editable}
              additionalFiscalReferences={product.additional_fiscal_references}
              onUpdated={(additionalFiscalReferences) => {
                product.additional_fiscal_references =
                  additionalFiscalReferences;
                this.props.onUpdated(product);
              }}
              hidden={(key) => this._hidden(key)}
            />
          </Collapsible>

          <Collapsible
            id={"transport-documents"}
            title={"Transport Documents"}
            defaultExpanded={this._isExpandedField(
              "transport_documents_section"
            )}
            hidden={
              this._hidden("transport_documents") ||
              this._isHiddenField("transport_documents_section")
            }
            renderToolbar={() =>
              this._renderSetting(
                "transport_documents_section",
                "Transport Documents",
                true
              )
            }
          >
            <TransportDocuments
              editable={editable}
              listKey={this._getListKey("CommonDocumentsType")}
              transportDocuments={product.transport_documents}
              placeholder={(key, value) => this._placeholder(key, value)}
              onUpdated={(transportDocuments) => {
                product.transport_documents = transportDocuments;
                this.props.onUpdated(product);
              }}
              hidden={(key) => this._hidden(key)}
            />
          </Collapsible>

          <Collapsible
            id={"dangerous-goods"}
            title={"Dangerous Goods"}
            defaultExpanded={this._isExpandedField("dangerous_goods_section")}
            hidden={
              this._hidden("dangerous_goods") ||
              this._isHiddenField("dangerous_goods_section")
            }
            renderToolbar={() =>
              this._renderSetting(
                "dangerous_goods_section",
                "Dangerous Goods",
                true
              )
            }
          >
            <DangerousGoods
              editable={editable}
              dangerousGoods={product.dangerous_goods}
              placeholder={(key, value) => this._placeholder(key, value)}
              onUpdated={(dangerousGoods) => {
                product.dangerous_goods = dangerousGoods;
                this.props.onUpdated(product);
              }}
              hidden={(key) => this._hidden(key)}
            />
          </Collapsible>
        </div>

        <Collapsible
          id={"containers"}
          title={"Containers"}
          defaultExpanded={this._isExpandedField("containers_section")}
          hidden={
            this._hidden("containers") ||
            this._isHiddenField("containers_section")
          }
          renderToolbar={() =>
            this._renderSetting(
              "containers_section",
              "Containers",
              true
            )
          }
        >
          <Containers
            editable={editable}
            containers={product.containers}
            onUpdated={(containers) => {
              product.containers = containers;
              this.props.onUpdated(product);
            }}
            hidden={(key) => this._hidden(key)}
          />
        </Collapsible>

        {showSettingsModal && (
          <ProductSettings
            show={showSettingsModal}
            setting={selectedSetting}
            product={product}
            onUpdated={(extra) => {
              product.extra = extra;
              this.setState({
                product,
                showSettingsModal: false,
                selectedSetting: null,
                accordionKey: this.state.accordionKey + 1,
              });
            }}
            onHide={() => {
              this.setState({
                showSettingsModal: false,
                selectedSetting: null,
              });
            }}
          />
        )}
      </div>
    );
  }
}

Form.defaultProps = {
  declaration: true,
};


const VISIBLE_SECTIONS = {
  ais: {
    G4G3: [
      "name",
      "description",
      "gross_mass",
      "net_mass",
      "supplementary_units",
      "cus_code",
      "quota_order_no",
      "transaction_nature",

      "commodity_code",
      "commodity_code.taric",

      "valuation",
      "valuation.statistical",
      "valuation.amount",
      "valuation.currency",

      "previous_documents",
      "previous_document_type",
      "previous_document_identifier",
      "previous_document_line_id",

      "operations",
      "operations.code",
      "operations.amount",

      "documents",
      "documents.type",
      "documents.identifier",

      "packages",
      "packages.type",
      "packages.count",
      "packages.shipping_marks",

      "additional_information",
      "additional_information.code",
      "additional_information.text",
    ],
    H1: [
      "name",
      "description",
      "gross_mass",
      "net_mass",
      "supplementary_units",
      "cus_code",
      "quota_order_no",
      "transaction_nature",

      "commodity_code",
      "commodity_code.taric",
      "commodity_code.taric_additional_codes",
      "commodity_code.national_additional_codes",

      "procedure",
      "previous_procedure",

      "valuation",
      "valuation.statistical",
      "valuation.indicator",
      "valuation.amount",
      "valuation.method",
      "valuation.preference",
      "valuation.currency",

      "previous_documents",
      "previous_document_type",
      "previous_document_identifier",
      "previous_document_line_id",

      "dates_and_places",
      "dates_and_places.destination_country",
      "dates_and_places.destination_region",
      "dates_and_places.dispatch_country",
      "dates_and_places.origin_country",
      "dates_and_places.preferential_origin_country",
      "dates_and_places.acceptance_date",

      "operations",
      "operations.code",
      "operations.amount",

      "documents",
      "documents.type",
      "documents.identifier",

      "packages",
      "packages.type",
      "packages.count",
      "packages.shipping_marks",

      "additional_procedures",
      "additional_procedures.code",

      "additional_information",
      "additional_information.code",
      "additional_information.text",

      "additional_fiscal_references",
      "additional_fiscal_references.code",
      "additional_fiscal_references.identifier",
    ],
    H7: [
      "name",
      "description",
      "gross_mass",
      "supplementary_units",

      "commodity_code",
      "commodity_code.taric",

      "valuation",
      "valuation.amount",
      "valuation.currency",
      "valuation.destination_transport_amount",
      "valuation.destination_transport_currency",

      "previous_documents",
      "previous_document_type",
      "previous_document_identifier",

      "documents",
      "documents.type",
      "documents.identifier",

      "packages",
      "packages.count",

      "additional_procedures",
      "additional_procedures.code",

      "additional_information",
      "additional_information.code",
      "additional_information.text",

      "additional_fiscal_references",
      "additional_fiscal_references.code",
      "additional_fiscal_references.identifier",

      "transport_documents",
      "transport_documents.type",
      "transport_documents.reference_number",
    ]
  },
  aes: {
    B1: [
      "name",
      "description",
      "gross_mass",
      "net_mass",
      "supplementary_units",
      "cus_code",
      "transaction_nature",

      "commodity_code",
      "commodity_code.taric",
      "commodity_code.taric_additional_codes",
      "commodity_code.national_additional_codes",

      "procedure",
      "previous_procedure",

      "valuation",
      "valuation.statistical",
      "valuation.amount",

      "previous_documents",
      "previous_document_type",
      "previous_document_identifier",
      "previous_document_line_id",

      "dates_and_places",
      "dates_and_places.destination_country",
      "dates_and_places.dispatch_country",
      "dates_and_places.origin_country",

      "documents",
      "documents.type",
      "documents.identifier",
      "documents.document_line_id",

      "packages",
      "packages.type",
      "packages.count",
      "packages.shipping_marks",

      "additional_procedures",
      "additional_procedures.code",

      "additional_information",
      "additional_information.code",
      "additional_information.text",

      "additional_references",
      "additional_references.type",
      "additional_references.reference_number",

      "transport_documents",
      "transport_documents.type",
      "transport_documents.reference_number",

      "dangerous_goods",
      "dangerous_goods.type",
    ],
  },
  cds: {
    H1: [
      "name",
      "description",
      "gross_mass",
      "net_mass",
      "supplementary_units",
      "cus_code",
      "transaction_nature",

      "commodity_code",
      "commodity_code.taric",
      "commodity_code.taric_additional_codes",
      "commodity_code.national_additional_codes",

      "procedure",
      "previous_procedure",

      "valuation",
      "valuation.statistical",
      "valuation.indicator",
      "valuation.amount",
      "valuation.method",
      "valuation.preference",
      "valuation.currency",

      "previous_documents",
      "previous_document_type",
      "previous_document_identifier",
      "previous_document_line_id",

      "dates_and_places",
      "dates_and_places.dispatch_country",
      "dates_and_places.origin_country",
      "dates_and_places.preferential_origin_country",

      "operations",
      "operations.code",
      "operations.amount",

      "documents",
      "documents.type",
      "documents.identifier",
      "documents.name",
      "documents.lpco_exemption_code",
      "documents.submitter_name",
      "documents.submitter_role_code",
      "documents.writeoff_quantity",
      "documents.writeoff_amount",

      "packages",
      "packages.type",
      "packages.count",
      "packages.shipping_marks",

      "additional_procedures",
      "additional_procedures.code",

      "additional_information",
      "additional_information.code",
      "additional_information.text",

      "containers",
      "containers.identification_number",
    ],
    B1: [
      "name",
      "description",
      "gross_mass",
      "net_mass",
      "transaction_nature",
      "supplementary_units",

      "commodity_code",
      "commodity_code.taric",
      "commodity_code.national_additional_codes",

      "procedure",
      "previous_procedure",

      "valuation",
      "valuation.statistical",
      "valuation.amount",
      "valuation.currency",

      "documents",
      "documents.type",
      "documents.identifier",
      "documents.name",
      "documents.lpco_exemption_code",
      "documents.submitter_name",
      "documents.submitter_role_code",
      "documents.writeoff_quantity",
      "documents.writeoff_amount",

      "packages",
      "packages.type",
      "packages.count",
      "packages.shipping_marks",

      "additional_procedures",
      "additional_procedures.code",

      "additional_information",
      "additional_information.code",
      "additional_information.text",
    ]
  },
  nhd: {
    H7: [
      "name",
      "description",
      "gross_mass",
      "supplementary_units",

      "commodity_code",
      "commodity_code.taric",

      "valuation",
      "valuation.amount",
      "valuation.currency",
      "valuation.destination_transport_amount",
      "valuation.destination_transport_currency",

      "previous_documents",
      "previous_document_type",
      "previous_document_identifier",

      "documents",
      "documents.type",
      "documents.identifier",

      "packages",
      "packages.count",

      "additional_procedures",
      "additional_procedures.code",

      "additional_information",
      "additional_information.code",
      "additional_information.text",

      "additional_references",
      "additional_references.type",
      "additional_references.reference_number",

      "transport_documents",
      "transport_documents.type",
      "transport_documents.reference_number",
    ],
    H1: [
      "name",
      "cus_code",
      "description",
      "gross_mass",
      "supplementary_units",
      "transaction_nature",

      "commodity_code",
      "commodity_code.taric",
      "commodity_code.taric_additional_codes",
      "commodity_code.national_additional_codes",

      "procedure",
      "previous_procedure",

      "valuation",
      "valuation.statistical",
      "valuation.indicator",
      "valuation.amount",
      "valuation.method",
      "valuation.preference",
      "valuation.currency",
      "valuation.destination_transport_amount",
      "valuation.destination_transport_currency",

      "previous_documents",
      "previous_document_type",
      "previous_document_identifier",
      "previous_document_line_id",

      "dates_and_places",
      "dates_and_places.destination_country",
      "dates_and_places.destination_region",
      "dates_and_places.dispatch_country",
      "dates_and_places.origin_country",
      "dates_and_places.preferential_origin_country",
      "dates_and_places.acceptance_date",

      "documents",
      "documents.type",
      "documents.identifier",
      "documents.document_line_id",
      "documents.cc_qualifier_code",
      "documents.submitter_name",
      "documents.writeoff_quantity",
      "documents.writeoff_amount",

      "packages",
      "packages.type",
      "packages.count",
      "packages.shipping_marks",

      "additional_procedures",
      "additional_procedures.code",

      "additional_information",
      "additional_information.code",
      "additional_information.text",

      "additional_references",
      "additional_references.type",
      "additional_references.reference_number",

      "transport_documents",
      "transport_documents.type",
      "transport_documents.reference_number",
    ]
  }
};

const LIST_KEY_MAPPINGS = {
  AdditionalProcedure: {
    ais: "AdditionalProcedure",
    aes: "AdditionalProcedure_AES",
    cds: "AdditionalProcedure_CDS_Import",
    birds: "AdditionalProcedure_CDS_BIRDS",
    nhd: "AdditionalProcedure_NHD",
    dms: "AdditionalProcedure_DMS",
  },
  AdditionalInformationCode: {
    ais: "AdditionalInformationCode",
    aes: "AdditionalInformationCode_AES",
    cds_export: "AdditionalInformationCode_CDS",
    cds: "AdditionalInformationCode_CDS_Import",
    ics2: "AdditionalInformationCode_ICS2",
    nhd: "AdditionalInformationCode_NHD",
    dms: "AdditionalInformationCode_DMS",
  },
  CommonDocumentsType: {
    ais: "CommonDocumentsType",
    cds: "CommonDocumentsType_CDS",
    nhd: "CommonDocumentsType_NHD",
    dms: "CommonDocumentsType_DMS",
  },
  CountryCodesEU: {
    ais: "CountryCodesEU",
    aes: "CountryCodesFullList_AES",
    cds: "CountryCodesFullList_CDS",
    nhd: "CountryCodesEU_NHD",
  },
  PreviousDocumentType: {
    ais: "PreviousDocumentType",
    aes: "PreviousDocumentType_AES",
    cds: "PreviousDocumentType_CDS",
    nhd: "PreviousDocumentType_NHD",
    dms: "PreviousDocumentType_DMS",
  },
  AdditionalReferenceType: {
    aes: "AdditionalReferenceType_AES",
    nhd: "AdditionalReferenceType_NHD",
    dms: "AdditionalReferenceType_DMS",
  }
}

const DATA_ELEMENT_MAPPINGS = {
  description: {
    legacy: "Description (6/8)",
    standard: "Description (18 05 001 000)",
  },
  gross_mass: {
    legacy: "Gross Mass (6/5)",
    standard: "Gross Mass (18 04 001 000)",
  },
  net_mass: {
    legacy: "Net Mass (6/1)",
    standard: "Net Mass (18 01 001 000)",
  },
  supplementary_units: {
    legacy: "Supplementary Units (6/2)",
    standard: "Supplementary Units (18 02 001 000)",
  },
  cus_code: {
    legacy: "Cus Code (6/13)",
    standard: "Cus Code (18 08 001 000)",
  },
  "valuation.statistical": {
    legacy: "Statistical Value (8/6)",
    standard: "Statistical Value (99 06 001 000)",
  },
  "packages.type": {
    legacy: "Package Type (6/9)",
    standard: "Package Type (18 06 003 000)",
  },
  "packages.shipping_marks": {
    legacy: "Shipping Remarks (6/11)",
    standard: "Shipping Remarks (18 06 054 000)",
  },
  "packages.count": {
    legacy: "Number (6/10)",
    standard: "Number (18 06 004 000)",
  },
  "product.quantity": {
    legacy: "Item Quantity",
    standard: "Item Quantity (12 01 006 000)",
  },
  "valuation.transaction_nature": {
    legacy: "Transaction Nature (8/5)",
    standard: "Transaction Nature (99 05 001 000)",
  },
  "document.type": {
    legacy: "Document Type",
    standard: "Document Type (12 03 002 000)"
  },
  "document.identifier": {
    legacy: "Document Identifier",
    standard: "Document Identifier (12 03 001 000)",
  },
  "additional_procedures.code": {
    legacy: "Additional Procedure",
    standard: "Additional Procedure (11 10 001 000)",
  },
  "additional_information.code": {
    legacy: "Code",
    standard: "Code (12 02 008 000)",
  },
  "additional_information.text": {
    legacy: "Text",
    standard: "Text (12 02 009 000)",
  },
  "additional_references.type": {
    legacy: "Type",
    standard: "Type (12 04 002 000)",
  },
  "additional_references.reference_number": {
    legacy: "Reference Number",
    standard: "Reference Number (12 04 001 000)",
  },
  "transport_documents.type": {
    legacy: "Type",
    standard: "Type (12 05 002 000)",
  },
  "transport_documents.reference_number": {
    legacy: "Reference Number",
    standard: "Reference Number (12 05 001 000)",
  },
  "dangerous_goods.type": {
    legacy: "Type",
    standard: "Type (18 07 055 000)",
  },
  "valuation.destination_transport_amount": {
    legacy: "Transport & Insurance Costs to Destination Amount",
    standard: "Transport & Insurance Costs to Destination Amount (14 15 014 000)",
  },
  "valuation.destination_transport_currency": {
    legacy: "Transport & Insurance Costs to Destination Currency",
    standard: "Transport & Insurance Costs to Destination Currency (14 15 012 000)",
  },
  "valuation.amount": {
    legacy: "Item Price (4/14)",
    standard: "Item Price (14 14 014 000)",
  },
  "valuation.currency": {
    legacy: "Currency",
    standard: "Currency (14 14 012 000)",
  },
  "valuation.indicator": {
    legacy: "Indicator (4/13)",
    standard: "Indicator (14 07 000 000)",
  },
  "valuation.method": {
    legacy: "Valuation Method (4/16)",
    standard: "Valuation Method (14 10 000 000)",
  },
  "dates_and_places.acceptance_date": {
    legacy: "Acceptance Date",
    standard: "Acceptance Date",
  },
  "operations.code": {
    legacy: "Code",
    standard: "Code (14 04 008 000)",
  },
  "operations.amount": {
    legacy: "Amount",
    standard: "Amount (14 04 014 000)",
  },
  "Destination Region (5/9)": {
    legacy: "Destination Region (5/9)",
    standard: "Destination Region (16 03 000 000)",
  },
  "Preferential Origin Country (5/16)": {
    legacy: "Preferential Origin Country (5/16)",
    standard: "Preferential Origin Country (16 09 000 000)",
  },
  "Previous Document Type": {
    legacy: "Previous Document Type",
    standard: "Previous Document Type (12 01 002 000)",
  },
  previous_document_identifier: {
    legacy: "Previous Document Identifier",
    standard: "Previous Document Identifier (12 01 001 000)",
  },
  "Previous Document Line ID": {
    legacy: "Previous Document Line ID",
    standard: "Previous Document Line ID"
  },
  "TARIC Code (6/15)": {
    legacy: "TARIC Code (6/15)",
    standard: "TARIC Code (18 09 059 000)"
  },
  "Procedure Code (1/10)": {
    legacy: "Procedure Code (1/10)",
    standard: "Procedure Code (11 09 001 000)"
  },
  "Previous Procedure Code (1/10)": {
    legacy: "Previous Procedure Code (1/10)",
    standard: "Previous Procedure Code (11 09 002 000)"
  },
  "Taric Additional Codes (6/16)": {
    legacy: "Taric Additional Codes (6/16)",
    standard: "Taric Additional Codes (18 09 059 000)",
  },
  "National Additional Codes (6/17)": {
    legacy: "National Additional Codes (6/17)",
    standard: "National Additional Codes (18 09 060 000)"
  },
  "Origin Country (5/15)": {
    legacy: "Origin Country (5/15)",
    standard: "Origin Country (16 08 001 000)"
  },
  "Destination Country (5/8)": {
    legacy: "Destination Country (5/8)",
    standard: "Destination Country (16 03 001 000)"
  },
  "Dispatch Country (5/14)": {
    legacy: "Dispatch Country (5/14)",
    standard: "Dispatch Country (16 07 001 000)"
  },
}

const EXPORT_SUBTYPES = ["B1", "B2", "B4", "C1 B&E", "C1 C&F"]

const IMPORT_SUBTYPES = ["H1", "H2", "H3", "H4", "H5", "H6", "H7", "I1 C&F", "I1 B&E"]

//   All fields / visible sections
//   "name",
//   "description",
//   "gross_mass",
//   "net_mass",
//   "supplementary_units",
//   "cus_code",
//   "quota_order_no",
//   "transaction_nature",
//
//   "commodity_code",
//   "commodity_code.taric",
//   "commodity_code.taric_additional_codes",
//   "commodity_code.national_additional_codes",
//
//   "procedure",
//   "previous_procedure",
//
//   "valuation",
//   "valuation.statistical",
//   "valuation.indicator",
//   "valuation.amount",
//   "valuation.method",
//   "valuation.preference",
//   "valuation.currency",
//   "valuation.destination_transport_amount",
//   "valuation.destination_transport_currency",
//
//   "previous_documents",
//   "previous_document_type",
//   "previous_document_identifier",
//   "previous_document_line_id",
//
//
//   "dates_and_places",
//   "dates_and_places.destination_country",
//   "dates_and_places.destination_region",
//   "dates_and_places.dispatch_country",
//   "dates_and_places.origin_country",
//   "dates_and_places.preferential_origin_country",
//   "dates_and_places.acceptance_date",
//
//   "operations",
//   "operations.code",
//   "operations.amount",
//
//   "documents",
//   "documents.type",
//   "documents.identifier",
//   "documents.name",
//   "documents.lpco_exemption_code",
//
//   "packages",
//   "packages.type",
//   "packages.count",
//   "packages.shipping_marks",
//
//   "additional_procedures",
//   "additional_procedures.code",
//
//   "additional_information",
//   "additional_information.code",
//   "additional_information.text",
//
//   "additional_references",
//   "additional_references.type",
//   "additional_references.reference_number",
//
//   "additional_fiscal_references",
//   "additional_fiscal_references.code",
//   "additional_fiscal_references.identifier",
//
//   "transport_documents",
//   "transport_documents.type",
//   "transport_documents.reference_number",
//
//   "dangerous_goods",
//   "dangerous_goods.type",
//
//   "containers",
//   "containers.identification_number",
